class SearchableGamesUtil {
    constructor (options) {
        this.countryId = null;
        this.apiUrl = '';
        this.isMobile = false;

        ({
            // gamesWrapper: this.gamesWrapper,
            MAXIMUM_GAMES_PER_LOAD: this.MAXIMUM_GAMES_PER_LOAD,
            apiUrl: this.apiUrl,
            languageCode: this.languageCode,
            country: this.countryId,
            isMobile: this.isMobile,
        } = options);

        this.isMobile = this.isMobile ?? false;
        // this.searchTimeout = null;
        this.selectedCategory = null;
        this.selectedCollection = null;
        this.selectedSecondaryCollection = null;
        this.providerId = null;
        this.individuationValue = null;
        this.searchText = '';
        this.page = 0;
        this.ids = [];
        this.externalIds = [];
        this.currentRequest = null;
        this.hasNextPageRequest = false;
        this.pageCount = -1;
        this.getRandom = false;
    }

    abort() {
        this.currentRequest?.abort();
    }

    setPageSize(size) {
        this.MAXIMUM_GAMES_PER_LOAD = size;
    }

    getParams() {
        let params = {
            searchText: this.searchText,
            perPage: this.MAXIMUM_GAMES_PER_LOAD,
            page: this.page,
            languageCode: this.languageCode,
            country: this.countryId,
            isMobile: this.isMobile
        };
        if (this.providerId)
            params.providerId = this.providerId;
        if (this.selectedCategory)
            params.categoryId = this.selectedCategory;
        if (this.selectedCollection)
            params.collectionId = this.selectedCollection;
        if (this.selectedSecondaryCollection)
            params.secondaryCollectionId = this.selectedSecondaryCollection;
        if (this.individuationValue)
            params.individuationValue = this.individuationValue;
        if (this.ids)
            params.ids = this.ids;
        if (this.externalIds)
            params.externalIds = this.externalIds;
        if (this.getRandom)
            params.getRandom = this.getRandom;

        return params;
    }

    hasNextPage() {
        return this.hasNextPageRequest;
    }

    getPageCount() {
        return this.pageCount >= 0 ? this.pageCount : null;
    }

    async requestGameData() {
        const self = this;
        let params = self.getParams();
        return new Promise((resolve, reject) => {
            this.currentRequest = $.get({
                url: self.apiUrl,
                method: 'GET',
                data: params,
                success: function (data, textStatus, request) {
                    self.pageCount = parseInt(request.getResponseHeader('X-Pagination-Page-Count'));
                    self.hasNextPageRequest = self.pageCount - parseInt(params.page+1) <= 0 ? false : true;
                    let result = data;
                    resolve(result);
                },
                error: function (data) {
                    reject(data);
                }, complete: function() {
                    self.currentRequest = null;
                }
            });
        });
    }

    getGames() {
        let result = [];
        let gamesData = this.requestGameData();
        for(let game of gamesData)
        {
            result.push(generateGameHMTL(game));
        }

        return result;
    }

    getGamesData() {
        return this.requestGameData();
    }

    resetPages()
    {
        this.page = 0;
    }

    loadParams(params)
    {
        if (params.hasOwnProperty('selectedCategory'))
            this.selectedCategory = params.selectedCategory;
        if (params.hasOwnProperty('providerId'))
            this.providerId = params.providerId;
        if (params.hasOwnProperty('searchText'))
            this.searchText = params.searchText;
        if (params.hasOwnProperty('selectedCollection'))
            this.selectedCollection = params.selectedCollection;
        if (params.hasOwnProperty('selectedSecondaryCollection'))
            this.selectedSecondaryCollection = params.selectedSecondaryCollection;
        if (params.hasOwnProperty('languageCode'))
            this.languageCode = params.languageCode;
        if (params.hasOwnProperty('individuationValue'))
            this.individuationValue = params.individuationValue;
        if (params.hasOwnProperty('ids'))
            this.ids = params.ids;
        if (params.hasOwnProperty('externalIds'))
            this.externalIds = params.externalIds;
        if (params.hasOwnProperty('getRandom'))
            this.getRandom = params.getRandom;
    }

    clone()
    {
        const clone = new SearchableGamesUtil({
            MAXIMUM_GAMES_PER_LOAD: this.MAXIMUM_GAMES_PER_LOAD,
            apiUrl: this.apiUrl,
            languageCode: this.languageCode,
            country: this.countryId,
            isMobile: this.isMobile,
        });

        clone.loadParams(this.getParams());
        clone.page = this.page;
        clone.pageCount = this.pageCount;

        return clone;
    }
}
